<template>
    <div>
        <hero />

        <v-container class="py-5 px-0" fluid>
            <About />

            <Possibility />

            <Experience />

            <Skills />

            <Portfolio />

            <Contact />
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'Home',

    components: {
        Hero: () => import('@/views/Hero'),
        About: () => import('@/views/About'),
        Possibility: () => import('@/views/Possibility'),
        Experience: () => import('@/views/Experience'),
        Skills: () => import('@/views/Skills'),
        Portfolio: () => import('@/views/Portfolio'),
        Contact: () => import('@/views/Contact'),
    },
};
</script>
